import { render, staticRenderFns } from "./jsDan.vue?vue&type=template&id=f2b38d78&scoped=true&"
import script from "./jsDan.vue?vue&type=script&lang=js&"
export * from "./jsDan.vue?vue&type=script&lang=js&"
import style0 from "./jsDan.vue?vue&type=style&index=0&id=f2b38d78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b38d78",
  null
  
)

export default component.exports